import { Col, DatePicker, DatePickerProps, Input, Row, InputRef } from "antd";
import moment from 'moment';
import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import './DateTimePickerCustom.scss';

interface Props {
  value?: moment.Moment | null;
  showTime: boolean;
  disabledDate: DatePickerProps['disabledDate'];
  onChange: (value: moment.Moment) => void;
}

export default function DateTimePickerCustom(props: Props) {
  const selected = props.value ? props.value : null;
  
const minuteInput = useRef<InputRef>(null);
  const [hourValue, setHourValue] = useState(selected?.format('HH'));
  const [minuteValue, setMinuteValue] = useState(selected?.format('mm'));
  const [dateValue, setDateValue] = useState(selected);
  const dateFormat = 'DD/MM/YYYY';

  useEffect(() => {
    datepickerChange();
  }, [dateValue, hourValue, minuteValue]);

  function onDateChange(dateSelected: moment.Moment | null) {
    setDateValue(dateSelected);
  }

  function onMinuteChange(event: ChangeEvent<HTMLInputElement>) {
    const value = Number(event.target.value);
    if (value < 0 || value >= 60) {
      alert('nhập phút > 0 và < 60');
      setMinuteValue('');
    } else {
      setMinuteValue(value.toString());
    }
  }

  function onHourChange(event: ChangeEvent<HTMLInputElement>) {
    const value = Number(event.target.value);
    if (value < 0 || value >= 24) {
      alert('nhập giờ > 0 và < 24');
      setHourValue('');
    } else {
      if (event.target.value.length == 2) {
        minuteInput.current?.select();
      }
      setHourValue(event.target.value);
    }
  }

  function datepickerChange() {
    if (!dateValue) {
      return;
    }

    let momentTimeReturn = dateValue.clone();
    if (props.showTime) {
      if (hourValue?.length == 2 && minuteValue?.length == 2) {
        momentTimeReturn.add(hourValue, 'hours').add(minuteValue, 'minutes');
      }
    }
    props.onChange(momentTimeReturn);
  }

  return (
    <Row className="datepicker-custom" gutter={8}>
      {props.showTime && (
        <>
          <Col xs={12}>
            <DatePicker
              format={dateFormat}
              placeholder={dateFormat}
              onChange={(date) => onDateChange(date)}
              disabledDate={props.disabledDate}
              value={dateValue}
            />
          </Col>
          <Col xs={12} className="d-flex align-items-center ">
            <Input
              placeholder="HH"
              maxLength={2}
              type="number"
              onChange={onHourChange}
              value={hourValue}
            />
            <span className="px-1">:</span>
            <Input
              placeholder="MM"
              maxLength={2}
              type="number"
              onChange={onMinuteChange}
              ref={minuteInput}
              value={minuteValue}
            />
          </Col>
        </>
      )}
    </Row>
  );
}
